<!-- <div class="show-slider-wrapper">
    <div 
        [@sliderAnimation]="selectedIndex"
        slideControl
        [itemsLength]="itemsLength"
        [autoStart]="autoStart"
        #ctrl="slideControl"
        (selectedIndex)="selectedIndex = $event"
        (actualIndex)="actualIndex = $event"
        class="slider-container">
        <div 
            class="slide" *ngFor="let slide of slides"
            [ngStyle]="{'background-image':'url('+slide.imgSrc+')'}">
        </div>   
    </div>
    <div class="overlay-wrapper" kwsetImageWidth #gridContainer>
        <div *ngFor="let overlay of overLayGridContent;let i = index" [class]="'cell-'+i">
            <img src="{{overlay?.imgSrc}}" alt="">
        </div>
    </div>    
</div> -->
<ng-container *ngIf="isPreview;else rendered">
    <div class="show-slider-wrapper" #showSliderWrapper>
        <div class="slide-track" [style.--view-port-width]="slideWidth">
            <div [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId" class="grid-cell-container cell-shadow banner" *ngFor="let gridCell of showSlides" [gridCell]="gridCell" kweOptionalClasses>
                <div class="bg-img-layer" [style.--bg-image]="'url(' + gridCell.imgSrc + ')'"></div>
                <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
                <div class="content-layer">
                    <div class="content-layout" [ngClass]="gridCell.layoutClass">
                        <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="navigator">
            <button nbButton (click)="ctrl.previous()" size="tiny">Previous</button>
        <button nbButton (click)="ctrl.next()" size="tiny">Next</button>
        <button nbButton size="tiny"*ngFor="let item of showSlides;let i=index" [class.active]="i==actualIndex" (click)="ctrl.setIndex(i)" >{{i}}</button>
        </div> -->
    </div>
</ng-container>
<ng-template #rendered>
    <div class="show-slider-wrapper" #showSliderWrapper 
    slideControl
    [selectedIndex]="selectedIndex"
    [itemsLength]="itemsLength"
    [autoStart]="autoStart"
    #ctrl="slideControl"
    (selectedIndex)="updateSelectedIndex($event)"
    (actualIndex)="actualIndex = $event">
        <div class="slide-track" [style.--view-port-width]="slideWidth" [@sliderAnimation]="{value:sliderState, params:{slidePosition:slidePosition}}">
            <div [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId" class="grid-cell-container cell-shadow banner" *ngFor="let gridCell of showSlides" [gridCell]="gridCell" kweOptionalClasses>
                <div class="bg-img-layer" [style.--bg-image]="'url(' + gridCell.imgSrc + ')'"></div>
                <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
                <div class="content-layer">
                    <div class="content-layout" [ngClass]="gridCell.layoutClass">
                        <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="navigator">
            <button nbButton (click)="ctrl.previous()" size="tiny">Previous</button>
        <button nbButton (click)="ctrl.next()" size="tiny">Next</button>
        <button nbButton size="tiny"*ngFor="let item of showSlides;let i=index" [class.active]="i==actualIndex" (click)="ctrl.setIndex(i)" >{{i}}</button>
        </div>
    </div>
</ng-template>

